export const TEST_IDS = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    linkWork: "nav-link-work",
    linkProcess: "nav-link-process",
    linkPricing: "nav-link-pricing",
    linkFaq: "nav-link-faq",
    ctaBook: "nav-cta-book-call",
  },
  hero: {
    root: "hero-section",
    ctaPricing: "hero-cta-pricing",
    ctaCall: "hero-cta-book-call",
    demoBadge: "hero-demo-badge",
  },
  marquee: "editorial-marquee",
  process: {
    root: "process-section",
    step: (i) => `process-step-${i}`,
  },
  portfolio: {
    root: "portfolio-section",
    item: (i) => `portfolio-item-${i}`,
  },
  pricing: {
    root: "pricing-section",
    card: (slug) => `pricing-card-${slug}`,
    cta: (slug) => `pricing-cta-${slug}`,
  },
  testimonials: {
    root: "testimonials-section",
    item: (i) => `testimonial-${i}`,
  },
  faq: {
    root: "faq-section",
    item: (i) => `faq-item-${i}`,
  },
  contact: {
    root: "contact-section",
    form: "contact-form",
    name: "contact-input-name",
    church: "contact-input-church",
    email: "contact-input-email",
    plan: "contact-select-plan",
    message: "contact-input-message",
    submit: "contact-submit",
    success: "contact-success",
  },
  calendly: "calendly-embed",
  footer: "site-footer",
};
